<template>
  <div class="menu-manage">
    <page-header title="菜单管理" icon="el-icon-menu" />
    
    <!-- 搜索区域 -->
    <el-card class="search-card">
      <div class="card-title">
        <i class="el-icon-search"></i>
        <span>筛选查询</span>
      </div>
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="菜单名称">
          <el-input v-model="searchForm.title" placeholder="请输入菜单名称" clearable class="filter-item"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.status" placeholder="菜单状态" clearable class="filter-item">
            <el-option label="显示" value="显示"></el-option>
            <el-option label="隐藏" value="隐藏"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="filter-buttons">
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 数据列表 -->
    <el-card class="table-card">
      <div class="card-title">
        <i class="el-icon-tickets"></i>
        <span>数据列表</span>
      </div>
      
      <!-- 操作按钮 -->
      <div class="operation-bar">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
      </div>

      <!-- 表格区域 -->
      <el-table
        v-loading="tableLoading"
        element-loading-text="加载中..."
        :data="tableData"
        row-key="id"
        border
        default-expand-all
        :tree-props="{children: 'children'}"
        style="width: 100%"
      >
        <el-table-column prop="title" label="菜单名称" min-width="200" align="center"></el-table-column>
        <el-table-column prop="icon" label="图标" width="100" align="center">
          <template slot-scope="scope">
            <i :class="scope.row.icon"></i>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" width="80" align="center"></el-table-column>
        <el-table-column prop="path" label="路由地址" min-width="200" align="center"></el-table-column>
        <el-table-column prop="component" label="组件路径" min-width="200" align="center"></el-table-column>
       
        <el-table-column prop="status" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === '显示' ? 'success' : 'info'">
              {{ scope.row.status }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="180" align="center"></el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">修改</el-button>
            <el-button type="text" size="small" @click="handleAddSub(scope.row)">新增</el-button>
            <el-button type="text" size="small" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 添加抽屉组件 -->
    <menu-form-drawer 
      ref="menuDrawer"
      :visible.sync="drawerVisible"
      :menu-data="currentMenu"
      @submit="handleSubmit"
    />
  </div>
</template>

<script>
import MenuFormDrawer from './components/MenuFormDrawer.vue'
import request from '@/utils/request'
import PageHeader from '@/components/common/PageHeader'

export default {
  name: 'MenuManage',
  components: {
    MenuFormDrawer,
    PageHeader
  },
  data() {
    return {
      // 搜索表单
      searchForm: {
        title: '',
        status: ''
      },
      // 表格数据
      tableData: [],
      drawerVisible: false,
      currentMenu: null,
      tableLoading: false // 添加表格加载状态
    }
  },
  created() {
    this.getMenuList()
  },
  methods: {
    // 获取菜单列表
    async getMenuList() {
      // 清空数据并显示加载状态
      this.tableData = []
      this.tableLoading = true
      
      try {
        const res = await request({
          url: '/api/v1/menu/all',
          method: 'POST'
        })

        if (res.status === 1 && res.data) {
          // 先格式化数据
          const formattedData = this.formatMenuData(res.data)
          // 转换为树形结构
          this.tableData = this.convertToTree(formattedData)
        } else {
          this.$message.error(res.msg || '获取菜单列表失败')
        }
      } catch (error) {
        console.error('获取菜单列表错误:', error)
        this.$message.error('获取菜单列表失败')
      } finally {
        // 无论成功失败都关闭加载状态
        this.tableLoading = false
      }
    },

    // 将扁平数据转换为树形结构
    convertToTree(data) {
      // 创建一个映射表来存储所有节点
      const map = new Map()
      const result = []

      // 先把所有节点放入映射表
      data.forEach(item => {
        map.set(item.id, { ...item, children: [] })
      })

      // 遍历所有节点，建立父子关系
      data.forEach(item => {
        const node = map.get(item.id)
        if (!item.parentId || item.parentId === '0') {
          // 顶级节点直接放入结果数组
          result.push(node)
        } else {
          // 非顶级节点放入父节点的children数组
          const parent = map.get(item.parentId)
          if (parent) {
            parent.children.push(node)
          }
        }
      })

      // 对每个层级的节点按sort字段排序
      this.sortTreeNodes(result)
      
      return result
    },

    // 递归对树形数据进行排序
    sortTreeNodes(nodes) {
      if (!nodes || !nodes.length) return
      
      // 按sort字段排序，sort值小的排在前面
      nodes.sort((a, b) => {
        const sortA = a.sort || 0
        const sortB = b.sort || 0
        return sortA - sortB
      })

      // 递归对子节点进行排序
      nodes.forEach(node => {
        if (node.children && node.children.length) {
          this.sortTreeNodes(node.children)
        }
      })
    },

    // 格式化菜单数据
    formatMenuData(data) {
      return data.map(item => {
        const menuTypeMap = {
          'F': '路径',
          'M': '菜单',
          'B': '按钮'
        }

        return {
          id: item.MenuID,
          parentId: item.ParentID,  // 确保包含parentId
          title: item.MenuName,
          icon: item.Icon,
          sort: item.Sort || 0,  // 确保sort有默认值
          path: item.Path,
          component: item.Component,
          status: item.Status === 1 ? '显示' : '隐藏',
          createTime: this.formatDateTime(item.CreatedAt),
          menuType: menuTypeMap[item.MenuType] || item.MenuType,
          permission: item.Permission,
          routeName: item.RouteName,
          isFrame: item.IsFrame
        }
      })
    },

    // 格式化时间
    formatDateTime(dateStr) {
      if (!dateStr) return ''
      const date = new Date(dateStr)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hour = String(date.getHours()).padStart(2, '0')
      const minute = String(date.getMinutes()).padStart(2, '0')
      const second = String(date.getSeconds()).padStart(2, '0')
      
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`
    },

    // 搜索方法也需要修改，以支持树形结构的搜索
    async handleSearch() {
      const { title, status } = this.searchForm
      if (!title && !status) {
        this.getMenuList()
        return
      }

      try {
        // 获取原始数据
        const res = await request({
          url: '/api/v1/menu/all',
          method: 'POST'
        })

        if (res.status === 1 && res.data) {
          // 先格式化所有数据
          const formattedData = this.formatMenuData(res.data)
          
          // 过滤符合条件的节点
          const filteredData = formattedData.filter(item => {
            const titleMatch = !title || item.title.includes(title)
            const statusMatch = !status || item.status === status
            return titleMatch && statusMatch
          })

          // 获取所有符合条件节点的父节点ID
          const parentIds = new Set()
          filteredData.forEach(item => {
            let currentId = item.parentId
            while (currentId && currentId !== '0') {
              parentIds.add(currentId)
              const parent = formattedData.find(p => p.id === currentId)
              currentId = parent ? parent.parentId : null
            }
          })

          // 合并符合条件的节点和它们的父节点
          const allNeededData = [
            ...filteredData,
            ...formattedData.filter(item => parentIds.has(item.id))
          ]

          // 转换为树形结构
          this.tableData = this.convertToTree(allNeededData)
        } else {
          this.$message.error(res.msg || '搜索失败')
        }
      } catch (error) {
        console.error('搜索错误:', error)
        this.$message.error('搜索失败')
      }
    },

    // 重置搜索
    handleReset() {
      this.searchForm = {
        title: '',
        status: ''
      }
      this.getMenuList()
    },

    handleAdd() {
      // 重置表单数据，确保所有字段为初始值
      this.currentMenu = {
        id: '',          // 确保 ID 为空
        menuId: '',      // 同时清空 menuId
        parentId: '0',
        title: '',       // 清空标题
        icon: '',        // 清空图标
        path: '',        // 清空路径
        component: '',   // 清空组件
        sort: 0,
        menuType: '菜单',
        status: 1,
        routeName: '',   // 清空路由名称
        permission: '',  // 清空权限标识
        isFrame: 0
      }
      this.drawerVisible = true
    },
    handleEdit(row) {
      this.currentMenu = {
        id: row.id,
        parentId: row.parentId || '0',
        title: row.title,
        icon: row.icon,
        path: row.path,
        component: row.component,
        sort: row.sort,
        menuType: row.menuType,
        status: row.status === '显示' ? 1 : 0,
        routeName: row.routeName,
        permission: row.permission,
        isFrame: row.isFrame
      }
      this.drawerVisible = true
    },
    handleAddSub(row) {
      // 新增子菜单时，只保留父级ID，其他都重置
      this.currentMenu = {
        id: '',          // 确保 ID 为空
        menuId: '',      // 同时清空 menuId
        parentId: row.id,
        title: '',       // 清空标题
        icon: '',        // 清空图标
        path: '',        // 清空路径
        component: '',   // 清空组件
        sort: 0,
        menuType: '菜单',
        status: 1,
        routeName: '',   // 清空路由名称
        permission: '',  // 清空权限标识
        isFrame: 0
      }
      this.drawerVisible = true
    },
    async handleDelete(row) {
      try {
        // 确认提示
        await this.$confirm('确认删除该菜单?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        // 如果有子菜单，提示不能删除
        if (row.children && row.children.length > 0) {
          this.$message.warning('该菜单下包含子菜单，不能直接删除')
          return
        }

        // 调用删除接口
        const res = await request({
          url: '/api/v1/menu/delete',
          method: 'POST',
          data: {
            menuId: row.id
          }
        })

        if (res.status === 1) {
          this.$message.success(res.msg || '删除成功')
          // 刷新菜单列表
          this.getMenuList()
        } else {
          this.$message.error(res.msg || '删除失败')
        }
      } catch (error) {
        if (error !== 'cancel') { // 排除用户取消的情况
          console.error('删除菜单错误:', error)
          this.$message.error('删除失败')
        }
      }
    },
    async handleSubmit(formData) {
  try {
    // 构造请求参数
    const params = {
      menuId: formData.id || '', // 新增时为空，编辑时传入ID
      menuName: formData.title,
      parentId: formData.parentId,
      sort: formData.sort,
      status: formData.status,
      icon: formData.icon,
      path: formData.path,
      component: formData.component,
      permission: formData.permission,
      visible: formData.status, // 使用status值
      isFrame: formData.isFrame,
      menu_type: this.getMenuTypeCode(formData.menuType), // 转换菜单类型
      route_name: formData.routeName
    }

    const res = await request({
      url: '/api/v1/menu/save',
      method: 'POST',
      data: params
    })

    if (res.status === 1) {
      this.$message.success('保存成功')
      this.drawerVisible = false
      // 刷新表格数据
      this.getMenuList()
    } else {
      this.$message.error(res.msg || '保存失败')
    }
  } catch (error) {
    console.error('保存菜单错误:', error)
    this.$message.error('保存失败')
  }
},

// 添加菜单类型转换方法
getMenuTypeCode(menuType) {
  const menuTypeMap = {
    '路径': 'F',
    '菜单': 'M',
    '按钮': 'B'
  }
  return menuTypeMap[menuType] || 'M'
},
  }
}
</script>

<style lang="scss" scoped>
.menu-manage {
  padding: 20px;
  background-color: #f0f2f5;
  min-height: calc(100vh - 84px);

  .search-card,
  .table-card {
    background: #fff;
    border-radius: 4px;
    margin-bottom: 20px;
    box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
    padding: 0;
  }

  .card-title {
    border-bottom: 1px solid #ebeef5;
    padding: 15px 20px;
    margin-bottom: 20px;
    font-size: 16px;
    font-weight: 500;
    color: #303133;
  }

  .card-title i {
    margin-right: 8px;
    color: #409EFF;
  }

  .filter-item {
    width: 200px;
  }

  .filter-buttons {
    margin-left: 10px;
  }

  .operation-bar {
    margin: 0 20px 20px;
  }

  .el-table {
    margin: 0 20px 20px;
  }

  :deep(.el-table td) {
    padding: 12px 0;
  }

  :deep(.el-table th) {
    background-color: #f5f7fa;
    padding: 12px 0;
  }
}
</style> 